import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getText, parseHTML } from '../utils/translations';

/**
 * A component for displaying translated text
 * @param {string} textId - The ID of the text in the translation files
 * @param {Object} props - Any additional props to pass to the element
 */
const TranslatedText = ({ textId, dangerousHTML, as: Component = 'span', ...props }) => {
  const { language } = useLanguage();
  const translatedText = getText(textId, language);
  
  if (dangerousHTML) {
    return (
      <Component 
        dangerouslySetInnerHTML={parseHTML(translatedText)} 
        {...props} 
      />
    );
  }
  
  return (
    <Component {...props}>
      {translatedText}
    </Component>
  );
};

export default TranslatedText; 